import React, { useMemo } from 'react';
import CaptionsChildViewContext from './CaptionsChildViewContext';
import { CaptionsChildViewProviderProps } from './types';

const CaptionsChildViewProvider: React.FC<CaptionsChildViewProviderProps> = ({
  className,
  topSlot,
  bottomSlot,
  media,
  switchLabel,
  startTranscribingWhenEnablingCaptions,
  isLoadingMediaInfo,
  isTranscribing,
  transcribingProgress,
  eddyProjectCuid,
  actionsSlot,
  onTranscriptionChange,
  onEditCaptionsStyle,
  onEditCaptionText,
  children,
}) => (
  <CaptionsChildViewContext.Provider
    value={useMemo(
      () => ({
        className,
        topSlot,
        bottomSlot,
        media,
        switchLabel,
        startTranscribingWhenEnablingCaptions,
        isLoadingMediaInfo,
        isTranscribing,
        transcribingProgress,
        eddyProjectCuid,
        actionsSlot,
        onTranscriptionChange,
        onEditCaptionsStyle,
        onEditCaptionText,
      }),
      [
        className,
        topSlot,
        bottomSlot,
        switchLabel,
        media,
        startTranscribingWhenEnablingCaptions,
        isLoadingMediaInfo,
        isTranscribing,
        transcribingProgress,
        eddyProjectCuid,
        actionsSlot,
        onTranscriptionChange,
        onEditCaptionsStyle,
        onEditCaptionText,
      ],
    )}
  >
    {children}
  </CaptionsChildViewContext.Provider>
);

export default CaptionsChildViewProvider;
